/** True when description field already holds AI/fallback bullet output (not contractor notes). */
export function isGeneratedEstimateDescription(text: string | null | undefined): boolean {
  if (!text || typeof text !== 'string') return false;
  const bulletCount = (text.match(/^-\s/gm) || []).length;
  return bulletCount >= 3 || /Includes all labor, materials, and standard components/i.test(text);
}

/** Contractor notes for AI — prefer item notes; avoid feeding prior AI output back in. */
export function buildAiUserDescription(
  notes: string | null | undefined,
  description: string | null | undefined
): string {
  const n = (notes || '').trim();
  const d = (description || '').trim();
  if (isGeneratedEstimateDescription(d)) {
    return n || '';
  }
  if (n && d) return `${d} — ${n}`;
  return d || n;
}

export function parseLineItemQuantity(value: unknown): number | null {
  const n = typeof value === 'number' ? value : Number(String(value ?? '').replace(/,/g, ''));
  return Number.isFinite(n) && n > 0 ? n : null;
}
